var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7071 31.7071C30.0976 31.3166 30.0976 30.6834 29.7071 30.2929L23.3431 23.9289C22.9526 23.5384 22.3195 23.5384 21.9289 23.9289C21.5384 24.3195 21.5384 24.9526 21.9289 25.3431L27.5858 31L21.9289 36.6569C21.5384 37.0474 21.5384 37.6805 21.9289 38.0711C22.3195 38.4616 22.9526 38.4616 23.3431 38.0711L29.7071 31.7071ZM1 32H29V30H1V32Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.37112e-8,
    x2: 0.999999,
    y2: 32,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildQuestion);
export default __webpack_public_path__ + "static/media/ChildQuestion.bf40b4b34d27065354bbd162442ef63e.svg";
export { ForwardRef as ReactComponent };